<template>
	<div class="container-infos shadow-blue-not-openned">
		<div class="subSectionTitleWithoutborder">
			<span>🚫 Zone dangereuse</span>
		</div>
		<p @click="dialog = true" class="deactivate-link">Désactiver mon compte</p>

		<!-- Modal to user confirm account deletion -->
		<v-dialog v-model="dialog" max-width="500">
			<v-card>
				<v-card-title class="headline"> Confirmation de désactivation </v-card-title>

				<v-card-text>
					<p>Êtes-vous sûr de vouloir désactiver votre compte ?</p>
					<p>Cette action est irréversible et toutes vos données seront supprimées.</p>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text :disabled="loading" @click="dialog = false"> Annuler </v-btn>
					<v-btn color="error" text :loading="loading" @click="confirmDeactivation"> Désactiver </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Modal to inform user about account deletion -->
		<v-dialog v-model="deletedDialog" max-width="500" persistent>
			<v-card>
				<v-card-title class="headline">Compte désactivé</v-card-title>

				<v-card-text>
					<p>Votre compte a été supprimé.</p>
					<p>Vous nous manquerez. Merci d'avoir utilisé notre service.</p>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="closeDeletedDialog">Fermer</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'SelfDeactivate',

	data() {
		return {
			dialog: false,
			deletedDialog: false,
			loading: false,
		};
	},
	methods: {
		async confirmDeactivation() {
			this.loading = true;

			try {
				if (localStorage.getItem('token') != null) {
					axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
				}
				await axios.put('/api/users/deactivate');

				this.deletedDialog = true;
			} catch (error) {
				console.error('Error deactivating account:', error);
				this.dialog = false;
			} finally {
				this.loading = false;
			}
		},

		closeDeletedDialog() {
			this.deletedDialog = false;
			this.$router.push({ name: 'Logout' });
		},
	},
};
</script>

<style scoped lang="scss">
.v-btn {
	text-transform: none;
}

.deactivate-link {
	color: #f44336;
	cursor: pointer;
	&:hover {
		text-decoration: none;
	}
}

.container-infos {
	width: 100%;
	height: auto;
	border-radius: 8px;
	margin-bottom: 20px;
	padding: 20px 20px 20px 20px;
}

.subSectionTitleWithoutborder {
	font-weight: bold;
	margin-bottom: 30px;
	color: grey;
}
</style>
